export default __webpack_public_path__ + "static/media/business-4.3e51e68d.jpg";